import { DragObjectWithType } from 'react-dnd';
import { dndTypes } from '../helpers/constants';

export type Tile = {
    id: number,
};

export enum Orientation {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
}

export type BoardState = { id: number, row: number, column: number }[];

export type TileDropItem = DragObjectWithType & {
    id: number,
    type: dndTypes.TILE_FROM_HAND | dndTypes.TILE_FROM_BOARD,
};
export type TileGroupDropItem = DragObjectWithType & {
    id: number,
    tiles: number[],
    orientation: Orientation,
    type: typeof dndTypes.TILE_GROUP,
};

export type HandState = { id: number }[];

interface BaseCommand {
    action: 'split' | 'peel' | 'dump';
    seed: number;
    userId: number | string;
}

interface DumpCommand extends BaseCommand {
    action: 'dump';
    tileToDump: number;
}

interface SplitCommand extends BaseCommand {
    action: 'split';
}

interface PeelCommand extends BaseCommand {
    action: 'peel';
}
export type Command = DumpCommand | SplitCommand | PeelCommand;

export type User = {
    userId: string,
    userName: string,
};

